<template>
  <v-container grid-list-md>

    <v-layout wrap>
      <v-flex xs12>
        <v-card>
          <v-form>
            <v-card-title><h3>Module {{ moduleId }}</h3></v-card-title>
            <v-card-text>
              <v-layout column wrap>
                <v-flex>
                  <strong>Author:</strong> {{ author }}
                </v-flex>
                <v-flex>
                  <strong>Category:</strong> {{ category }}
                </v-flex>
                <v-flex>
                  <strong>CPD Points:</strong> {{ cpdPoints }}
                </v-flex>
                <v-flex>
                  <strong>Created At:</strong> {{ createdAt }}
                </v-flex>
                <v-flex>
                  <strong>Description:</strong> {{ description }}
                </v-flex>
                <v-flex>
                  <strong>Image:</strong> {{ image }}
                </v-flex>
                <v-flex>
                  <strong>Minimum Score:</strong> {{ minimumScore }}
                </v-flex>
                <v-flex>
                  <strong>Title:</strong> {{ title }}
                </v-flex>
                <v-flex>
                  <strong>User Id:</strong> {{ userId }}
                </v-flex>
                <v-flex>
                  <strong>Video:</strong> {{ video }}
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex>
        <v-btn
          @click="dialogAddQuestion = true"
          color="primary"
        >Add Question</v-btn>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="dialogAddQuestion"
    >
      <add-question-form
        :apiUrl="apiUrl"
        :moduleId="moduleId"
      ></add-question-form>
    </v-dialog>

    <question
      :apiUrl="apiUrl"
      :moduleId="moduleId"
    ></question>

  </v-container>
</template>

<script>
import axios from 'axios'
import AddQuestionForm from '@/components/admin/module/addQuestionForm'
import Question from '@/components/admin/module/question'
import config from '../../../../configApi'
const apiUrl = config.apiUrl

export default {
  components: {
    AddQuestionForm,
    Question
  },
  created () {
    this.moduleId = this.$route.params.id
  },
  data () {
    return {
      dialogAddQuestion: false,
      moduleId: null,
      author: null,
      category: null,
      cpdPoints: null,
      createdAt: null,
      description: null,
      image: null,
      minimumScore: null,
      title: null,
      userId: null,
      video: null
    }
  },
  methods: {
    getModuleById (moduleId) {
      axios.get(apiUrl + '/module/' + moduleId).then((res) => {
        this.author = res.data.author
        this.category = res.data.category
        this.cpdPoints = res.data.cpd_points
        this.createdAt = res.data.created_at
        this.description = res.data.description
        this.image = res.data.image
        this.minimumScore = res.data.minimum_score
        this.title = res.data.title
        this.userId = res.data.user_id
        this.video = res.data.video
      })
    }
  },
  props: {
    apiUrl: String
  },
  watch: {
    moduleId (v) {
      this.getModuleById(v)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/admin/module/index.vue